import { buildProps } from '@ll-plus/utils'
import { ExtractPropTypes } from 'vue'

import type PaginationPro from './paginationProProps.vue'

export const paginationProPagingStyles = ['simple', 'outline', 'solid'] as const

export const paginationProAlignment = ['left', 'center', 'right'] as const
export const paginationProProps = buildProps({
  showBg: {
    type: Boolean,
    default: false,
  },
  // 数据总数函数
  showTotal: {
    type: Function,
    default: undefined,
  },
  // 是否显示数据总数
  isShowTotal: {
    type: Boolean,
    default: true,
  },
  // 上一步图标
  prevIcon: {
    type: String,
    default: '',
  },
  // 下一步图标
  nextIcon: {
    type: String,
    default: '',
  },
  pagingStyle: {
    type: String,
    values: paginationProPagingStyles,
    default: 'simple',
  },
  /**
   * @description 分页对齐方式，可选值：left、center、right
   */
  alignment: {
    type: String,
    values: paginationProAlignment,
    default: 'left',
  },
  isGray: {
    type: Boolean,
    default: false,
  },
} as const)

export type PaginationProProps = ExtractPropTypes<typeof paginationProProps>

export type PaginationProInstance = InstanceType<typeof PaginationPro>
